import { render, staticRenderFns } from "./Envio.vue?vue&type=template&id=5cdbdf19&"
import script from "./Envio.vue?vue&type=script&lang=js&"
export * from "./Envio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports